<app-dialog [visible]="visibility" (closed)="closeDialog()" [title]="'Download Document ' + contract.name"
    [showCloseButton]="true" class="max-w-[37.5rem]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col justify-center items-center gap-2 p-4">
            <img [src]="'images/download_doc.png' | assetUrl" alt="contract" class="w-1/2 h-1/2">
            <div class="flex flex-col gap-2">
                <span class="font-medium">Download as</span>
                <app-select [(value)]="selectedType" [options]="downloadOptions" [config]="downloadConfig" />
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel" (clicked)="closeDialog()" />
            <app-button variant="filled" severity="primary" (clicked)="downloadDoc()" [loading]="loading"
                [disabled]="!selectedType" label="Download" />
        </div>
    </ng-template>
</app-dialog>
